import React from "react";
import { Route, Routes } from "react-router-dom";

import ConversationReport from "@/components/screens/ConversationReport";
import { CONVERSATION_REPORT_MESSAGES } from "@/messages/conversation-report/conversation-report.messages";

const ConversationReportPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<ConversationReport messages={CONVERSATION_REPORT_MESSAGES} />} />
      <Route path="/" element={<ConversationReport messages={CONVERSATION_REPORT_MESSAGES} />} />
    </Routes>
  );
};

export default ConversationReportPage;
